export default "__VITE_ASSET__BSSrB_pI__"